import { useQuery } from '@tanstack/react-query';
import { useEffect } from 'react';

import {
  fetchCompanyDocumentBlobAsync,
  getCompanyDocumentByTypeIdAsync
} from '../../../http/DocumentManagement/DocumentManagement';
import queryKeys from './queryKeys';

const useCompanyProfileImage = (companyId: number) => {
  const query = useQuery({
    queryKey: [queryKeys.companyProfileImage, companyId],
    queryFn: async () => {
      const data = await getCompanyDocumentByTypeIdAsync(companyId, 15);
      let url = '';
      if (data.id) {
        try {
          const blob = await fetchCompanyDocumentBlobAsync(data.id);
          url = URL.createObjectURL(blob);
        } catch {
          url = '';
        }
      }
      return {
        id: data.id,
        fileName: data.fileName,
        url
      };
    },
    refetchOnReconnect: true,
    refetchOnWindowFocus: true,
    refetchOnMount: true,
    enabled: companyId != 0 && companyId != null
  });

  // Revoke the object URL when it is replaced by a refetch (this query refetches
  // on mount/focus/reconnect) or when the consumer unmounts. Without this every
  // refetch leaks a blob for the lifetime of the session — and this hook feeds
  // NavigationHeader, which mounts on essentially every page.
  const url = query.data?.url;
  useEffect(() => {
    return () => {
      if (url) {
        URL.revokeObjectURL(url);
      }
    };
  }, [url]);

  return query;
};

export default useCompanyProfileImage;
